import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router";
import {
  addListingType,
  addNewToHubzu,
  addMarketingPhase,
  addAuctionEndingToday,
  addOwnItNow,
  addNobuyerpremium,
  addBrokerCoOp,
  addCashOnly,
  addCampaign,
  addCampaignId,
  addCampaignType,
  addIsPartOfCampaign,
  addOffers,
  addSearchBy,
  addPropertySubType,
  resetPropertySubType,
  addCategory,
  resetCategory,
  addPropertyStatus,
  resetPropertyStatus,
  addOccupancy,
  resetOccupancy,
  addSpecialAssetsTypes,
  resetSpecialAssetsTypes,
  addFeatured,
  resetFeatured,
  addPriceMin,
  addPriceMax,
  addAreaMin,
  addAreaMax,
  addBuiltYearMin,
  addBuiltYearMax,
  addBedrooms,
  addBathrooms,
  addMapParam,
  setPageNumber,
  addSort,
  resetPageNumber,
  addState,
} from "../../redux/SRP/propertiesSlice";
import FilterSingleItem from './FilterSingleItem';
import FilterMoreItem from './FilterMoreItem';
import { ShimmerButton } from "react-shimmer-effects";
import SaveSearchModal from './SaveSearchModal';
import SaveSearchButton from './SaveSearchButton';
import { getEventCategory, trackButtonClick, trackPageMount } from '@/utils/analytics';
import { trackFilterInteraction, getSrpLocationLabel } from '@/utils/filterTrackingService';
import { markInternalNavigation } from '@/utils/attributionCapture';

let hasTrackedFiltersView  = false

const FilterBar = ({isMobView}) => {
  const srpFilterInitData = useSelector((state) => state.srpFilter.srpFilterInitData);
  const srpDisabledFilter = useSelector((state) => state.srpFilter.srpDisabledFilter);
  const polygonId = useSelector((state) => state.srp.srpInitData.polygonId);
  const properties = useSelector((state) => state.properties);
  const {
    propertySubType,
    category,
    propertyStatus,
    occupancyStatus,
    sid,
    propertyShowMoreStatus,
    listingType,
    newToHubzu,
    marketingPhase,
    auctionEndingToday,
    ownItNow,
    nobuyerpremium,
    brokerCoOp,
    cashOnly,
    campaign,
    campaignId,
    campaignType,
    isPartOfCampaign,
    offers,
    searchBy,
    mapParam,
    pageNumber
  } = properties;
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const [isCommercial, setIsCommercial] = useState(false);
  const [disabledList, setDisabledList] = useState([]);
  const [disabledFilter, setDisabledFilter] = useState({});
  const [showModal, setShowModal] = useState(false);
  const nonCommercialFilters = ["CO", "CP", "MF", "MH", "MU", "OT", "PF", "SF", "SU", "TH", "UN", "VL"];
  const commercialFilters = ["AUS","CMU" ,"CVL", "CVS", "GST", "HNC", "HRM", "MAC","MHP", "OFS", "OTR", "RNB", "SFR", "WRH"];
  const dispatch = useDispatch();
  const queryParams = new URLSearchParams(window.location.search);
  const URLPropertySubType = queryParams.getAll("propertySubType");
  const URLAssetTypes = queryParams.getAll("category");
  const URLPropertyStatus = queryParams.getAll("propertyStatus");
  const URLOccupancy = queryParams.getAll("occupancyStatus");
  const URLSpecialAssetsTypes = queryParams.getAll("sid");
  const URLFeatured = queryParams.getAll("propertyShowMoreStatus");
  const URLListingType = queryParams.get("listingType");

  const URLSwLatLng = queryParams.get("swLatLng");
  const URLNeLatLng = queryParams.get("neLatLng");
  const URLCenterPoint = queryParams.get("centerPoint");
  const URLRect = queryParams.get("rect");
  const URLZoomValue = queryParams.get("zoomValue");

  const URLPageNumber = queryParams.get("pageNumber");

  if ((URLPageNumber && pageNumber !== Number(URLPageNumber))) {
    dispatch(setPageNumber(parseInt(URLPageNumber)));
  }
  if ((URLSwLatLng && mapParam?.swLatLng !== URLSwLatLng) || (URLNeLatLng && mapParam?.neLatLng !== URLNeLatLng)) {
    dispatch(addMapParam({swLatLng: URLSwLatLng, neLatLng: URLNeLatLng, centerPoint: URLCenterPoint, rect: URLRect, zoomValue: URLZoomValue}))
  }

  if (URLListingType && listingType !== URLListingType && URLListingType.length > 0) {
    dispatch(addListingType({value: URLListingType, isUpdate: false}));
  }
  const URLNewToHubzu = queryParams.get("newToHubzu");
  if (URLNewToHubzu && newToHubzu !== URLNewToHubzu) {
    dispatch(addNewToHubzu({ value: URLNewToHubzu, isUpdate: false }));
  }
  const URLMarketingPhase = queryParams.get("marketingPhase");
  if (URLMarketingPhase && marketingPhase !== URLMarketingPhase) {
    dispatch(addMarketingPhase({ value: URLMarketingPhase, isUpdate: false }));
  }
  const URLAuctionEndingToday = queryParams.get("auctionEndingToday");
  if (URLAuctionEndingToday && auctionEndingToday !== URLAuctionEndingToday && URLAuctionEndingToday === 'Y') {
    dispatch(addAuctionEndingToday({ value: URLAuctionEndingToday, isUpdate: false }));
  }
  const URLOwnItNow = queryParams.get("ownItNow");
  if (URLOwnItNow && ownItNow !== URLOwnItNow) {
    dispatch(addOwnItNow({ value: URLOwnItNow, isUpdate: false }));
  }
  const URLNobuyerpremium = queryParams.get("nobuyerpremium");
  if (URLNobuyerpremium && nobuyerpremium !== URLNobuyerpremium) {
    dispatch(addNobuyerpremium({value: URLNobuyerpremium, isUpdate: false}));
  }
  const URLBrokerCoOp = queryParams.get("brokerCoOp");
  if (URLBrokerCoOp && brokerCoOp !== URLBrokerCoOp) {
    dispatch(addBrokerCoOp({value: URLBrokerCoOp, isUpdate: false}));
  }
  const URLCashOnly= queryParams.get("cashOnly");
  if (URLCashOnly && cashOnly !== URLCashOnly) {
    dispatch(addCashOnly({value: URLCashOnly, isUpdate: false}));
  }
  const URLCampaign= queryParams.get("campaign");
  if (URLCampaign && campaign !== URLCampaign) {
    dispatch(addCampaign({ value: URLCampaign, isUpdate: false }));
  }
  const URLCampaignId= queryParams.get("campaignId");
  if (URLCampaignId && campaignId !== URLCampaignId) {
    dispatch(addCampaignId({ value: URLCampaignId, isUpdate: false }));
  }
  const URLCampaignType= queryParams.get("campaignType");
  if (URLCampaignType && campaignType !== URLCampaignType) {
    dispatch(addCampaignType({ value: URLCampaignType, isUpdate: false }));
  }
  const URLIsPartOfCampaign= queryParams.get("isPartOfCampaign");
  if (URLIsPartOfCampaign && isPartOfCampaign !== URLIsPartOfCampaign) {
    dispatch(addIsPartOfCampaign({ value: URLIsPartOfCampaign, isUpdate: false }));
  }
  const URLOffers= queryParams.get("offers");
  if (URLOffers && offers !== URLOffers) {
    dispatch(addOffers({ value: URLOffers, isUpdate: false }));
  }
  const URLSearchBy= queryParams.get("searchBy");
  if (URLSearchBy && searchBy !== URLSearchBy) {
    dispatch(addSearchBy({ value: URLSearchBy, isUpdate: false }));
  }
  if (URLFeatured.length > 0) {
    URLFeatured.map((URL_FT) => {
      let flag = false;
      propertyShowMoreStatus.map((FT) => {
        if (URL_FT === FT) { flag = true }
      })
      if (!flag) {
        dispatch(addFeatured(URL_FT));
      }
    })
  }
  if (URLSpecialAssetsTypes.length > 0) {
    URLSpecialAssetsTypes.map((URL_SAT) => {
      let flag = false;
      sid.map((SAT) => {
        if (URL_SAT === SAT) { flag = true }
        if (!URLSpecialAssetsTypes.includes(SAT)) {
          dispatch(addSpecialAssetsTypes(SAT));
        }
      })
      if (!flag) {
        dispatch(addSpecialAssetsTypes(URL_SAT));
      }
    })
  }
  if (URLOccupancy.length > 0) {
    URLOccupancy.map((URL_OT) => {
      let flag = false;
      occupancyStatus.map((OT) => {
        if (URL_OT === OT) { flag = true }
      })
      if (!flag) {
        dispatch(addOccupancy(URL_OT));
      }
    })
  }
  if (URLPropertyStatus.length > 0) {
    URLPropertyStatus.map((URL_PS) => {
      let flag = false;
      propertyStatus.map((PS) => {
        if (URL_PS === PS) { flag = true }
      })
      if (!flag) {
        dispatch(addPropertyStatus(URL_PS));
      }
    })
  }
  if (URLAssetTypes.length > 0) {
    URLAssetTypes.map((URL_AT) => {
      let flag = false;
      category.map((assetType) => {
        if (URL_AT === assetType) { flag = true }
      })
      if (!flag) {
        dispatch(addCategory({value: URL_AT, isUpdate: true}));
      }
    })
  }
  if (URLPropertySubType.length > 0) {
    URLPropertySubType.map((URL_PST) => {
      let flag = false;
      propertySubType.map((PST) => {
        if (URL_PST === PST) { flag = true }
      })
      if (!flag) {
        dispatch(addPropertySubType(URL_PST));
      }
    })
  }
  const clearAll = pathname => {
    dispatch(addListingType({value: "", isUpdate: false}));
    dispatch(addNewToHubzu({value: "", isUpdate: false}));
    dispatch(addMarketingPhase({ value: "", isUpdate: false }));
    dispatch(addAuctionEndingToday({value: "", isUpdate: false}));
    dispatch(addOwnItNow({ value: "", isUpdate: false }));
    dispatch(addNobuyerpremium({ value: "", isUpdate: false }));
    dispatch(addBrokerCoOp({ value: "", isUpdate: false }));
    dispatch(addCashOnly({ value: "", isUpdate: false }));
    dispatch(addCampaign({ value: "", isUpdate: false}));
    dispatch(addCampaignId({ value: "", isUpdate: false}));
    dispatch(addCampaignType({ value: "", isUpdate: false}));
    dispatch(addIsPartOfCampaign({ value: "", isUpdate: false}));
    dispatch(addOffers({ value: "", isUpdate: false}));
    dispatch(addSearchBy({ value: "", isUpdate: false}));
    dispatch(resetPropertySubType());
    dispatch(resetCategory());
    dispatch(resetPropertyStatus());
    dispatch(resetOccupancy());
    dispatch(resetSpecialAssetsTypes());
    dispatch(resetFeatured());
    dispatch(addSort({ value: "sort=MostPopular", label: "Most Popular" }));
    dispatch(addState([]));
    dispatch(resetPageNumber(1));
    dispatch(addBedrooms(""));
    dispatch(addBathrooms(""));
    dispatch(addPriceMin(0));
    dispatch(addPriceMax(0));
    dispatch(addAreaMin(""));
    dispatch(addAreaMax(""));
    dispatch(addBuiltYearMin(0));
    dispatch(addBuiltYearMax(0));
    dispatch(addMapParam(""));

    if (pathname === '/commercial') {
      setIsCommercial(true);
    } else {
      setIsCommercial(false);
    }
    if (pathname.includes(`/auctions/condos`) && !propertySubType.includes('CO')) {
      dispatch(addPropertySubType('CO'));
    }
    if (pathname.includes(`/auctions/land`) && !propertySubType.includes('VL')) {
      dispatch(addPropertySubType('VL'));
    }
    if ((pathname === '/bank-owned' || pathname === '/bank-owned-properties-near-me' || pathname === '/bank-owned-near-me' || pathname.includes(`/bank-owned`)) && !category.includes('bankowned')) {
      dispatch(addCategory({value: 'bankowned', isUpdate: false}));
    }
    if ((pathname.includes(`/non-bank-owned`)) && !category.includes('nonbankowned')) {
      dispatch(addCategory({value: 'nonbankowned', isUpdate: false}));
    }
    if (pathname === '/commercial' && !category.includes('commercial')) {
      dispatch(addCategory({value: 'commercial', isUpdate: false}));
    }
    if ((pathname === '/foreclosures' || pathname === '/foreclosures-near-me' || pathname.includes(`/foreclosures`)) && !category.includes('foreclosure')) {
      dispatch(addCategory({value: 'foreclosure', isUpdate: false}));
    }
    if ((pathname === '/short-sale' || pathname === '/short-sale-properties-near-me' || pathname === '/short-sale-near-me' || pathname.includes(`/short-sale`)) && !category.includes('SHRT_SALE')) {
      dispatch(addCategory({value: 'SHRT_SALE', isUpdate: false}));
    }
    if ((pathname === '/traditional-sale') && listingType !== 'TRNL') {
      dispatch(addListingType({value: 'TRNL', isUpdate: false}));
    }
  }
  useEffect(() => {
    clearAll(pathname);
  }, [pathname]);

  useEffect(() => {
    // Track filters view when component mounts and filters are loaded
    if (srpFilterInitData.length > 0 && !hasTrackedFiltersView) {
      trackPageMount({
        pageName: "srp_filters_view",
        eventCategory: "NEW-SRP",
        eventLabel: `Filters displayed: ${srpFilterInitData.length} filters available`
      });
      hasTrackedFiltersView = true
    }
  }, [srpFilterInitData]);


  useEffect(() => {
    const disFilter = {propertySubType: [...srpDisabledFilter, ...((isCommercial || category.includes('commercial')) ? category?.length > 1 ? [] : nonCommercialFilters : commercialFilters)]};
    const disList = [];
    const enableDisableOption = {
      auctionEndingToday_N: 'listingType_TRNL',
      auctionEndingToday_Y: 'listingType_TRNL,marketingPhase_preList',
      category_commercial: 'sid,occupancyStatus,Beds,Baths,marketingPhase_preList,occupancyStatus_N,occupancyStatus_Y,propertyStatus_PACT_NON_COMMERCIAL',
      category_foreclosure: 'category_SHRT_SALE,category_bankowned(occupied),category_bankowned(nonoccupied),category_nonbankowned(occupied),category_nonbankowned(nonoccupied),marketingPhase_preList,listingType_TRNL,propertyStatus_UNDERCONTRACT,propertyStatus_UNDERREVIEW,propertyStatus_PACT_NON_COMMERCIAL,propertyStatus_PACT',
      category_npl: 'reservepricerevealed_RESERVE_PRICE_REVEALED,marketingPhase_preList,propertyStatus_WFA,propertyStatus_ACTIVE,propertyStatus_UNDERCONTRACT,propertyStatus_UNDERREVIEW,auctionEndingToday_Y,propertyShowMoreStatus_HOTPROPERTY,propertyShowMoreStatus_CLOSEOUTS,nobuyerpremium_NO_BUYER_PREMIUM,brokerCoOp_BROKER_CO_OP,cashOnly_CASH_ONLY,ownItNow_Y',
      listingType_AUCN: 'listingType_TRNL,category_npl',
      listingType_TRNL: 'listingType_AUCN,nobuyerpremium_NO_BUYER_PREMIUM,reservepricerevealed_RESERVE_PRICE_REVEALED,auctionEndingToday_N,auctionEndingToday_Y,propertyStatus_PACT_NON_COMMERCIAL,propertyStatus_PACT',
      marketingPhase_preList: 'category_SHRT_SALE,category_bankowned(occupied),category_bankowned(nonoccupied),category_nonbankowned(occupied),category_nonbankowned(nonoccupied),category_foreclosure,listingType_AUCN,listingType_TRNL,propertyShowMoreStatus_CLOSEOUTS,ownItNow_Y,nobuyerpremium_NO_BUYER_PREMIUM,reservepricerevealed_RESERVE_PRICE_REVEALED,propertyStatus_ACTIVE,propertyStatus_UNDERCONTRACT,propertyStatus_UNDERREVIEW,newToHubzu_NEW_TO_HUBZU,cashOnly_CASH_ONLY,auctionEndingToday_N',
      nobuyerpremium_NO_BUYER_PREMIUM: 'listingType_TRNL',
      ownItNow_Y: 'listingType_TRNL,propertyShowMoreStatus_CLOSEOUTS,propertyStatus_UNDERCONTRACT,category_SHRT_SALE,propertyStatus_UNDERREVIEW',
      propertyStatus_UNDERCONTRACT: 'auctionEndingToday_Y',
      propertyStatus_UNDERREVIEW: 'auctionEndingToday_Y'
    }
    for (const optionKey in enableDisableOption) {
      if (enableDisableOption.hasOwnProperty(optionKey)) {
        const [keyName, ...rest] = optionKey.split('_');
        const keyValue = rest.join('_');
        if ((typeof properties[keyName] === 'string' && properties[keyName] === keyValue) || (typeof properties[keyName] === 'object' && properties[keyName].includes(keyValue))) {
          const valueList = enableDisableOption[optionKey].split(',');
          valueList.filter((listItem) => {
            if (!listItem.includes('_')) {
              if (!disList.includes(listItem)) {
                disList.push(listItem);
              }
              return false;
            } else {
              return true;
            }
          }).forEach(optionValue => {
            const [disableKey, ...rest] = optionValue.split('_');
            const disableValue = rest.join('_');
            if (disFilter[disableKey]){
              if (!disFilter[disableKey].includes(disableValue)) {
                disFilter[disableKey].push(disableValue);
              }
            } else {
              disFilter[disableKey] = [disableValue];
            }
          })
        }
      }
    }
    if (!(isCommercial || category.includes('commercial'))) {
      if (disFilter['propertyStatus']) {
        disFilter['propertyStatus'].push("PACT");
      } else {
        disFilter['propertyStatus'] = ["PACT"];
      }
    } else {
      if (disFilter['propertyStatus']) {
        disFilter['propertyStatus'].push("PACT_NON_COMMERCIAL");
      } else {
        disFilter['propertyStatus'] = ["PACT_NON_COMMERCIAL"];
      }
    }
    setDisabledFilter(disFilter);
    setDisabledList(disList);
  }, [srpDisabledFilter, isCommercial, properties]);

  const getFilterComponent = () => {
    const FilterComponent = [];
    srpFilterInitData.map((filterList) => {
      if (filterList.fieldIDUI === 'propertySubType' && !disabledList.includes(filterList.fieldIDUI)) {
        const propertiesItem = filterList?.facetContents?.listContents.map((list) => ({...list, fieldIDUI: filterList?.fieldIDUI}))
        FilterComponent[0] = (
          <FilterSingleItem
            panelId={filterList.fieldIDUI}
            key={filterList.fieldIDUI}
            propertyName={filterList.name}
            propertiesItem={propertiesItem}
            selectedList={propertySubType}
            onClick={(item) => {
              // Use a static variable to track if we're already processing this item
              if (!window._processingItem) {
                window._processingItem = true;
                const isAlreadySelected = propertySubType.includes(item.uiurl);
                dispatch(addPropertySubType(item.uiurl));

                // Track via API
                trackFilterInteraction(isAlreadySelected ? 'FILTER_DESELECTED' : 'FILTER_SELECTED',
                  isAlreadySelected ? { deselectedFilters: `propertySubType=${item.uiurl}` } : {}
                );

                trackButtonClick({
                  eventName: "filter_toggle",
                  eventParams: {
                    action: isAlreadySelected ? "deselected" : "selected",
                    filter_type: "property_type",
                  },
                  eventSource: "SRP FILTERS",
                  eventCategory: "NEW-SRP",
                  eventLabel: `Property Type ${isAlreadySelected ? "Deselected" : "Selected"}:${item.displayname}| Location: ${getSrpLocationLabel()}`,
                });
                // Reset the processing flag after a short delay
                setTimeout(() => {
                  window._processingItem = false;
                }, 300);
              }
            }}
            onClearPress={() => {
              let addressBarURL = new URL(window.location.href);
              addressBarURL.searchParams.forEach((value, key) => {
                if (key === "propertySubType") {
                  addressBarURL.searchParams.delete("propertySubType");
                }
              });
              history.pushState({}, "", addressBarURL.href);
              dispatch(resetPropertySubType());

              // Track via API - pass all deselected values
              const deselectedPropertyTypeFilters = propertySubType.map(v => `propertySubType=${v}`).join(',');
              trackFilterInteraction('FILTER_DESELECTED', {
                deselectedFilters: deselectedPropertyTypeFilters
              });

              trackButtonClick({
                eventName: "filter_toggle",
                eventParams: {
                  action: "cleared",
                  filter_type: "property_type",
                },
                eventSource: "SRP FILTERS",
                eventCategory: "NEW-SRP",
                eventLabel: `Property Type Deselected: ${deselectedPropertyTypeFilters} | Location: ${getSrpLocationLabel()}`,
              });
            }}
            isMobView={isMobView}
            disabledFilter={disabledFilter}
          />
        );
      } else if (filterList.fieldIDUI === 'category'&& !disabledList.includes(filterList.fieldIDUI)) {
        const propertiesItem = filterList?.facetContents?.listContents.map((list) => ({...list, fieldIDUI: filterList?.fieldIDUI}))
        const additionalList = srpFilterInitData.filter(filterData => filterData.fieldIDUI === "listingType" && !disabledList.includes(filterData.fieldIDUI))
        if (additionalList?.length > 0) {
          const newList = additionalList[0]?.facetContents?.listContents.filter((list, index) => index && list).map(list=>({...list, fieldIDUI: additionalList[0]?.fieldIDUI}));
          propertiesItem.splice(4, 0, ...newList)
        }
        let selectedList = [...category];
        if (listingType !== '' && listingType !== 'AUCN') {
          selectedList.push(listingType);
        }
        FilterComponent[1] = (
          <FilterSingleItem
            panelId={filterList.fieldIDUI}
            key={filterList.fieldIDUI}
            propertyName={filterList.name}
            propertiesItem={propertiesItem}
            selectedList={selectedList}
            onClick={(item) => {
              // Prevent multiple executions
              if (!window._processingCategoryItem) {
                window._processingCategoryItem = true;

                const id = item.uiurl;
                if (item?.fieldIDUI === filterList?.fieldIDUI) {
                  if (pageNumber !== 1) dispatch(setPageNumber(1));
                  dispatch(addCategory({ value: id, isUpdate: true }));
                  if (
                    (pathname === "/bank-owned" ||
                      pathname === "/bank-owned-properties-near-me" ||
                      pathname === "/bank-owned-near-me") &&
                    id === "bankowned" &&
                    category.includes("bankowned")
                  ) {
                    markInternalNavigation(); navigate("/allstates/auctions");
                  }
                  if (
                    pathname === "/commercial" &&
                    id === "commercial" &&
                    category.includes("commercial")
                  ) {
                    markInternalNavigation(); navigate("/allstates/auctions");
                  }
                  if (
                    (pathname === "/foreclosures" ||
                      pathname === "/foreclosures-near-me") &&
                    id === "foreclosure" &&
                    category.includes("foreclosure")
                  ) {
                    markInternalNavigation(); navigate("/allstates/auctions");
                  }
                  if (
                    (pathname === "/short-sale" ||
                      pathname === "/short-sale-properties-near-me" ||
                      pathname === "/short-sale-near-me") &&
                    id === "SHRT_SALE" &&
                    category.includes("SHRT_SALE")
                  ) {
                    markInternalNavigation(); navigate("/allstates/auctions");
                  }
                  if (
                    pathname === "/traditional-sale" &&
                    id === "TRNL" &&
                    listingType.includes("TRNL")
                  ) {
                    markInternalNavigation(); navigate("/allstates/auctions");
                  }
                  if (
                    pathname === "/traditional-sale" &&
                    id === "foreclosure" &&
                    listingType.includes("TRNL")
                  ) {
                    dispatch(addListingType({ value: "", isUpdate: false }));
                    markInternalNavigation(); navigate("/allstates/auctions");
                  }
                } else if (item?.fieldIDUI === "listingType") {
                  if (pageNumber !== 1) dispatch(setPageNumber(1));
                  dispatch(addListingType({ value: id, isUpdate: true }));
                }
                // Track category selection/deselection
                const isAlreadySelected = category.includes(id);

                // Track via API
                trackFilterInteraction(isAlreadySelected ? 'FILTER_DESELECTED' : 'FILTER_SELECTED',
                  isAlreadySelected ? { deselectedFilters: `${item.fieldIDUI}=${id}` } : {}
                );

                trackButtonClick({
                  eventName: "filter_toggle",
                  eventParams: {
                    action: isAlreadySelected ? "deselected" : "selected",
                    filter_type: "asset_type",
                  },
                  eventSource: "SRP FILTERS",
                  eventCategory: "NEW-SRP",
                  eventLabel: `Asset Type ${isAlreadySelected ? "Deselected" : "Selected"}:${item.displayname}| Location: ${getSrpLocationLabel()}`,
                });
                // Reset the processing flag after a short delay
                setTimeout(() => {
                  window._processingCategoryItem = false;
                }, 300);
              }
            }}
            onClearPress={() => {
              let addressBarURL = new URL(window.location.href);
              addressBarURL.searchParams.forEach((value, key) => {
                if (key === "category") {
                  addressBarURL.searchParams.delete("category");
                }
              });
              history.pushState({}, "", addressBarURL.href);
              if (pageNumber !== 1) dispatch(setPageNumber(1));
              dispatch(resetCategory());
              if (listingType !== "" && listingType !== "AUCN") {
                dispatch(addListingType({ value: "", isUpdate: true }));
              }

              // Navigate away from category-specific routes when clearing
              if (pathname === "/commercial" || pathname === "/bank-owned" || pathname === "/bank-owned-properties-near-me" || pathname === "/bank-owned-near-me" || pathname === "/foreclosures" || pathname === "/foreclosures-near-me" || pathname === "/short-sale" || pathname === "/short-sale-properties-near-me" || pathname === "/short-sale-near-me" || pathname === "/traditional-sale") {
                markInternalNavigation(); navigate("/allstates/auctions");
              }

              // Track via API - pass all deselected values
              const deselectedCategoryFilters = [
                ...category.map(v => `category=${v}`),
                ...(listingType && listingType !== 'AUCN' ? [`listingType=${listingType}`] : [])
              ].join(',');
              trackFilterInteraction('FILTER_DESELECTED', { deselectedFilters: deselectedCategoryFilters });

              trackButtonClick({
                eventName: "filter_toggle",
                eventParams: { action: "cleared", filter_type: "asset_type" },
                eventSource: "SRP FILTERS",
                eventCategory: "NEW-SRP",
                eventLabel: `Asset Type Deselected: ${deselectedCategoryFilters} | Location: ${getSrpLocationLabel()}`,
              });
            }}
            disabledFilter={disabledFilter}
            isMobView={isMobView}
          />
        );
      } else if (filterList.fieldIDUI === 'propertyStatus'&& !disabledList.includes(filterList.fieldIDUI)) {
        const propertiesItem = filterList?.facetContents?.listContents.map((list) => ({...list, fieldIDUI: filterList?.fieldIDUI}))
        const additionalList1 = srpFilterInitData.filter(filterData => filterData.fieldIDUI === "newToHubzu" && !disabledList.includes(filterData.fieldIDUI))
        const additionalList2 = srpFilterInitData.filter(filterData => filterData.fieldIDUI === "marketingPhase" && !disabledList.includes(filterData.fieldIDUI))
        const additionalList3 = srpFilterInitData.filter(filterData => filterData.fieldIDUI === "auctionEndingToday" && !disabledList.includes(filterData.fieldIDUI))
        if (additionalList1?.length > 0) {
          const newList = additionalList1[0]?.facetContents?.listContents.map((list) => ({...list, fieldIDUI: additionalList1[0]?.fieldIDUI}));
          propertiesItem.splice(0, 0, ...newList)
        }
        if (additionalList2?.length > 0) {
          const newList = additionalList2[0]?.facetContents?.listContents.map((list) => ({...list, fieldIDUI: additionalList2[0]?.fieldIDUI}));
          propertiesItem.splice(1, 0, ...newList)
        }
        if (additionalList3?.length > 0) {
          const newList = additionalList3[0]?.facetContents?.listContents.map((list) => ({...list, fieldIDUI: additionalList3[0]?.fieldIDUI}));
          propertiesItem.splice(7, 0, ...newList)
        }
        let selectedList = [...propertyStatus];
        if (newToHubzu !== '') {
          selectedList.push(newToHubzu);
        }
        if (marketingPhase !== '') {
          selectedList.push(marketingPhase);
        }
        if (auctionEndingToday !== '') {
          selectedList.push(auctionEndingToday);
        }
        FilterComponent[2] = (
          <FilterSingleItem
            panelId={filterList.fieldIDUI}
            key={filterList.fieldIDUI}
            propertyName={filterList.name}
            propertiesItem={propertiesItem}
            selectedList={selectedList}
            onClick={(item) => {
              // Prevent multiple executions
              if (!window._processingStatusItem) {
                window._processingStatusItem = true;

                if (pageNumber !== 1) dispatch(setPageNumber(1));

                // Determine which type of filter is being clicked and its current selection state
                let isAlreadySelected = false;

                if (item?.fieldIDUI === filterList?.fieldIDUI) {
                  isAlreadySelected = propertyStatus.includes(item.uiurl);
                  dispatch(addPropertyStatus(item.uiurl));
                } else if (item?.fieldIDUI === "newToHubzu") {
                  isAlreadySelected = newToHubzu === item.uiurl;
                  dispatch(
                    addNewToHubzu({ value: item.uiurl, isUpdate: true })
                  );
                } else if (item?.fieldIDUI === "marketingPhase") {
                  isAlreadySelected = marketingPhase === item.uiurl;
                  dispatch(
                    addMarketingPhase({ value: item.uiurl, isUpdate: true })
                  );
                } else if (item?.fieldIDUI === "auctionEndingToday") {
                  isAlreadySelected = auctionEndingToday === item.uiurl;
                  dispatch(
                    addAuctionEndingToday({ value: item.uiurl, isUpdate: true })
                  );
                }

                // Track via API
                trackFilterInteraction(isAlreadySelected ? 'FILTER_DESELECTED' : 'FILTER_SELECTED',
                  isAlreadySelected ? { deselectedFilters: `${item.fieldIDUI}=${item.uiurl}` } : {}
                );

                trackButtonClick({
                  eventName: "filter_toggle",
                  eventParams: {
                    action: isAlreadySelected ? "deselected" : "selected",
                    filter_type: "property_status",
                  },
                  eventSource: "SRP FILTERS",
                  eventCategory: "NEW-SRP",
                  eventLabel: `Property Status ${isAlreadySelected ? "Deselected" : "Selected"}:${item.displayname}| Location: ${getSrpLocationLabel()}`,
                });

                // Reset the processing flag after a short delay
                setTimeout(() => {
                  window._processingStatusItem = false;
                }, 300);
              }
            }}
            onClearPress={() => {
              let addressBarURL = new URL(window.location.href);
              addressBarURL.searchParams.forEach((value, key) => {
                if (key === "propertyStatus") {
                  addressBarURL.searchParams.delete("propertyStatus");
                }
              });
              history.pushState({}, "", addressBarURL.href);
              if (pageNumber !== 1) dispatch(setPageNumber(1));
              dispatch(resetPropertyStatus());
              dispatch(addNewToHubzu({ value: "", isUpdate: true }));
              dispatch(addMarketingPhase({ value: "", isUpdate: true }));
              dispatch(addAuctionEndingToday({ value: "", isUpdate: true }));

              // Track via API - pass all deselected values
              const deselectedStatusFilters = [
                ...propertyStatus.map(v => `propertyStatus=${v}`),
                ...(newToHubzu ? [`newToHubzu=${newToHubzu}`] : []),
                ...(marketingPhase ? [`marketingPhase=${marketingPhase}`] : []),
                ...(auctionEndingToday ? [`auctionEndingToday=${auctionEndingToday}`] : []),
              ].join(',');
              trackFilterInteraction('FILTER_DESELECTED', { deselectedFilters: deselectedStatusFilters });

              trackButtonClick({
                eventName: "filter_toggle",
                eventParams: { action: "cleared", filter_type: "property_status" },
                eventSource: "SRP FILTERS",
                eventCategory: "NEW-SRP",
                eventLabel: `Property Status Deselected: ${deselectedStatusFilters} | Location: ${getSrpLocationLabel()}`,
              });
            }}
            disabledFilter={disabledFilter}
            isMobView={isMobView}
          />
        );
      } else if (filterList.fieldIDUI === 'occupancyStatus' && !disabledList.includes(filterList.fieldIDUI)) {
        const propertiesItem = filterList?.facetContents?.listContents.map((list) => ({...list, fieldIDUI: filterList?.fieldIDUI}))
        FilterComponent[3] = (
          <FilterSingleItem
            panelId={filterList.fieldIDUI}
            key={filterList.fieldIDUI}
            propertyName={filterList.name}
            propertiesItem={propertiesItem}
            selectedList={occupancyStatus}
            onClick={(item) => {
              // Prevent multiple executions
              if (!window._processingOccupancyItem) {
                window._processingOccupancyItem = true;

                if (pageNumber !== 1) dispatch(setPageNumber(1));
                const isAlreadySelected = occupancyStatus.includes(item.uiurl);
                dispatch(addOccupancy(item.uiurl));

                // Track via API
                trackFilterInteraction(isAlreadySelected ? 'FILTER_DESELECTED' : 'FILTER_SELECTED',
                  isAlreadySelected ? { deselectedFilters: `occupancyStatus=${item.uiurl}` } : {}
                );

                trackButtonClick({
                  eventName: "filter_toggle",
                  eventParams: {
                    action: isAlreadySelected ? "deselected" : "selected",
                    filter_type: "occupancy_status",
                  },
                  eventSource: "SRP FILTERS",
                  eventCategory: "NEW-SRP",
                  eventLabel: `Occupancy Status ${isAlreadySelected ? "Deselected" : "Selected"}: ${item.displayname} | Location: ${getSrpLocationLabel()}`,
                });

                // Reset the processing flag after a short delay
                setTimeout(() => {
                  window._processingOccupancyItem = false;
                }, 300);
              }
            }}
            onClearPress={() => {
              let addressBarURL = new URL(window.location.href);
              addressBarURL.searchParams.forEach((value, key) => {
                if (key === "occupancyStatus") {
                  addressBarURL.searchParams.delete("occupancyStatus");
                }
              });
              history.pushState({}, "", addressBarURL.href);
              if (pageNumber !== 1) dispatch(setPageNumber(1));
              dispatch(resetOccupancy());

              // Track via API - pass all deselected values
              const deselectedOccupancyFilters = occupancyStatus.map(v => `occupancyStatus=${v}`).join(',');
              trackFilterInteraction('FILTER_DESELECTED', {
                deselectedFilters: deselectedOccupancyFilters
              });

              trackButtonClick({
                eventName: "filter_toggle",
                eventParams: { action: "cleared", filter_type: "occupancy_status" },
                eventSource: "SRP FILTERS",
                eventCategory: "NEW-SRP",
                eventLabel: `Occupancy Status Deselected: ${deselectedOccupancyFilters} | Location: ${getSrpLocationLabel()}`,
              });
            }}
            disabledFilter={disabledFilter}
            isMobView={isMobView}
          />
        );
      } else if (filterList.fieldIDUI === 'sid' && !disabledList.includes(filterList.fieldIDUI)) {
        const propertiesItem = filterList?.facetContents?.listContents.map((list) => ({...list, fieldIDUI: filterList?.fieldIDUI}))
        FilterComponent[4] = (
          <FilterSingleItem
            panelId={filterList.fieldIDUI}
            key={filterList.fieldIDUI}
            propertyName={filterList.name}
            propertiesItem={propertiesItem}
            skipIndex={1}
            selectedList={sid}
            onClick={(item) => {
              // Prevent multiple executions
              if (!window._processingSpecialAssetsItem) {
                window._processingSpecialAssetsItem = true;

                if (pageNumber !== 1) dispatch(setPageNumber(1));
                const isAlreadySelected = sid.includes(item.uiurl);
                dispatch(addSpecialAssetsTypes(item.uiurl));

                // Track via API
                trackFilterInteraction(isAlreadySelected ? 'FILTER_DESELECTED' : 'FILTER_SELECTED',
                  isAlreadySelected ? { deselectedFilters: `sid=${item.uiurl}` } : {}
                );

                trackButtonClick({
                  eventName: "filter_toggle",
                  eventParams: {
                    action: isAlreadySelected ? "deselected" : "selected",
                    filter_type: "special_asset_type",
                  },
                  eventSource: "SRP FILTERS",
                  eventCategory: "NEW-SRP",
                  eventLabel: `Special Asset Type ${isAlreadySelected ? "Deselected" : "Selected"}: ${item.displayname} | Location: ${getSrpLocationLabel()}`,
                });

                // Reset the processing flag after a short delay
                setTimeout(() => {
                  window._processingSpecialAssetsItem = false;
                }, 300);
              }
            }}
            onClearPress={() => {
              let addressBarURL = new URL(window.location.href);
              addressBarURL.searchParams.forEach((value, key) => {
                if (key === "sid") {
                  addressBarURL.searchParams.delete("sid");
                }
              });
              history.pushState({}, "", addressBarURL.href);
              if (pageNumber !== 1) dispatch(setPageNumber(1));
              dispatch(resetSpecialAssetsTypes());

              // Track via API - pass all deselected values
              const deselectedSpecialAssetFilters = sid.map(v => `sid=${v}`).join(',');
              trackFilterInteraction('FILTER_DESELECTED', {
                deselectedFilters: deselectedSpecialAssetFilters
              });

              trackButtonClick({
                eventName: "filter_toggle",
                eventParams: { action: "cleared", filter_type: "special_asset_type" },
                eventSource: "SRP FILTERS",
                eventCategory: "NEW-SRP",
                eventLabel: `Special Asset Type Deselected: ${deselectedSpecialAssetFilters} | Location: ${getSrpLocationLabel()}`,
              });
            }}
            disabledFilter={disabledFilter}
            isMobView={isMobView}
          />
        );
      } else if (filterList.fieldIDUI === 'propertyShowMoreStatus' && !disabledList.includes(filterList.fieldIDUI)) {
        const propertiesItem = filterList?.facetContents?.listContents.map((list) => ({...list, fieldIDUI: filterList?.fieldIDUI}))
        const additionalList1 = srpFilterInitData.filter(filterData => filterData.fieldIDUI === "ownItNow" && !disabledList.includes(filterData.fieldIDUI))
        const additionalList2 = srpFilterInitData.filter(filterData => filterData.fieldIDUI === "nobuyerpremium" && !disabledList.includes(filterData.fieldIDUI))
        const additionalList3 = srpFilterInitData.filter(filterData => filterData.fieldIDUI === "brokerCoOp" && !disabledList.includes(filterData.fieldIDUI))
        const additionalList4 = srpFilterInitData.filter(filterData => filterData.fieldIDUI === "cashOnly" && !disabledList.includes(filterData.fieldIDUI))
        if (additionalList1?.length > 0) {
          const newList = additionalList1[0]?.facetContents?.listContents.map((list) => ({...list, fieldIDUI: additionalList1[0]?.fieldIDUI}));
          propertiesItem.splice(2, 0, ...newList)
        }
        if (additionalList2?.length > 0) {
          const newList = additionalList2[0]?.facetContents?.listContents.map((list) => ({...list, fieldIDUI: additionalList2[0]?.fieldIDUI}));
          propertiesItem.splice(3, 0, ...newList)
        }
        if (additionalList3?.length > 0) {
          const newList = additionalList3[0]?.facetContents?.listContents.map((list) => ({...list, fieldIDUI: additionalList3[0]?.fieldIDUI}));
          propertiesItem.splice(4, 0, ...newList)
        }
        if (additionalList4?.length > 0) {
          const newList = additionalList4[0]?.facetContents?.listContents.map((list) => ({...list, fieldIDUI: additionalList4[0]?.fieldIDUI}));
          propertiesItem.splice(5, 0, ...newList)
        }
        let selectedList = [...propertyShowMoreStatus];
        if (ownItNow !== '') {
          selectedList.push(ownItNow);
        }
        if (nobuyerpremium !== '') {
          selectedList.push(nobuyerpremium);
        }
        if (brokerCoOp !== '') {
          selectedList.push(brokerCoOp);
        }
        if (cashOnly !== '') {
          selectedList.push(cashOnly);
        }
        FilterComponent[5] = (
          <FilterSingleItem
            panelId={filterList.fieldIDUI}
            key={filterList.fieldIDUI}
            propertyName={filterList.name}
            propertiesItem={propertiesItem}
            selectedList={selectedList}
            onClick={(item) => {
              // Prevent multiple exections
              if (!window._processingShowMoreItem) {
                window._processingShowMoreItem = true;

                if (pageNumber !== 1) dispatch(setPageNumber(1));

                let isAlreadySelected = false;

                if (item?.fieldIDUI === filterList?.fieldIDUI) {
                  isAlreadySelected = propertyShowMoreStatus.includes(
                    item.uiurl
                  );
                  dispatch(addFeatured(item.uiurl));
                } else if (item?.fieldIDUI === "ownItNow") {
                  isAlreadySelected = ownItNow === item.uiurl;
                  dispatch(addOwnItNow({ value: item.uiurl, isUpdate: true }));
                } else if (item?.fieldIDUI === "nobuyerpremium") {
                  isAlreadySelected = nobuyerpremium === item.uiurl;
                  dispatch(
                    addNobuyerpremium({ value: item.uiurl, isUpdate: true })
                  );
                } else if (item?.fieldIDUI === "brokerCoOp") {
                  isAlreadySelected = brokerCoOp === item.uiurl;
                  dispatch(
                    addBrokerCoOp({ value: item.uiurl, isUpdate: true })
                  );
                } else if (item?.fieldIDUI === "cashOnly") {
                  isAlreadySelected = cashOnly === item.uiurl;
                  dispatch(addCashOnly({ value: item.uiurl, isUpdate: true }));
                }

                // Track via API
                trackFilterInteraction(isAlreadySelected ? 'FILTER_DESELECTED' : 'FILTER_SELECTED',
                  isAlreadySelected ? { deselectedFilters: `${item.fieldIDUI}=${item.uiurl}` } : {}
                );

                trackButtonClick({
                  eventName: "filter_toggle",
                  eventParams: {
                    action: isAlreadySelected ? "deselected" : "selected",
                    filter_type: "featured",
                  },
                  eventSource: "SRP FILTERS",
                  eventCategory: "NEW-SRP",
                  eventLabel: `Featured ${isAlreadySelected ? "Deselected" : "Selected"}: ${item.displayname} | Location: ${getSrpLocationLabel()}`,
                });

                // Reset the processing flag after a short delay
                setTimeout(() => {
                  window._processingShowMoreItem = false;
                }, 300);
              }
            }}
            onClearPress={() => {
              let addressBarURL = new URL(window.location.href);
              addressBarURL.searchParams.forEach((value, key) => {
                if (key === "propertyShowMoreStatus") {
                  addressBarURL.searchParams.delete("propertyShowMoreStatus");
                }
              });
              history.pushState({}, "", addressBarURL.href);
              if (pageNumber !== 1) dispatch(setPageNumber(1));
              dispatch(resetFeatured());
              dispatch(addOwnItNow({ value: "", isUpdate: true }));
              dispatch(addNobuyerpremium({ value: "", isUpdate: true }));
              dispatch(addBrokerCoOp({ value: "", isUpdate: true }));
              dispatch(addCashOnly({ value: "", isUpdate: true }));

              // Track via API - pass all deselected values
              const deselectedFeaturedFilters = [
                ...propertyShowMoreStatus.map(v => `propertyShowMoreStatus=${v}`),
                ...(ownItNow ? [`ownItNow=${ownItNow}`] : []),
                ...(nobuyerpremium ? [`nobuyerpremium=${nobuyerpremium}`] : []),
                ...(brokerCoOp ? [`brokerCoOp=${brokerCoOp}`] : []),
                ...(cashOnly ? [`cashOnly=${cashOnly}`] : []),
              ].join(',');

              trackFilterInteraction('FILTER_DESELECTED', { deselectedFilters: deselectedFeaturedFilters });

              trackButtonClick({
                eventName: "filter_toggle",
                eventParams: { action: "cleared", filter_type: "features" },
                eventSource: "SRP FILTERS",
                eventCategory: "NEW-SRP",
                eventLabel: `Features Deselected: ${deselectedFeaturedFilters} | Location: ${getSrpLocationLabel()}`,
              });
            }}
            disabledFilter={disabledFilter}
            isMobView={isMobView}
          />
        );
      } else {
        <></>
      }
      FilterComponent[6] = (
      <FilterMoreItem
        panelId="more"
        key="more"
        panelBodyId="moreFeatured"
        propertyName="More"
        disabledList={disabledList}
        disabledFilter={disabledFilter}
        isMobView={isMobView}
        onClearPress={() => {
          if (pageNumber !== 1) dispatch(setPageNumber(1));
          let addressBarURL = new URL(window.location.href);
          if (addressBarURL.searchParams.has("priceRange")) {
            addressBarURL.searchParams.delete('priceRange');
          }
          dispatch(addPriceMin(0));
          dispatch(addPriceMax(0));
          if (addressBarURL.searchParams.has("squareFeetRange")) {
            addressBarURL.searchParams.delete('squareFeetRange');
          }
          dispatch(addAreaMin(""));
          dispatch(addAreaMax(""));
          if (addressBarURL.searchParams.has("yearBuiltRange")) {
            addressBarURL.searchParams.delete('yearBuiltRange');
          }
          dispatch(addBuiltYearMin(0));
          dispatch(addBuiltYearMax(0));
          if (addressBarURL.searchParams.has("bed")) {
            addressBarURL.searchParams.delete('bed');
          }
          dispatch(addBedrooms(""));
          if (addressBarURL.searchParams.has("bath")) {
            addressBarURL.searchParams.delete('bath');
          }
          dispatch(addBathrooms(""));
          history.pushState({}, '', addressBarURL.href);

          // Track via API - pass all deselected "More" filter values
          const deselectedMoreFilters = [];
          if (properties.price?.min > 0 || properties.price?.max > 0) {
            const min = properties.price.min || 0;
            const max = properties.price.max === 1000001 ? '1000000plus' : (properties.price.max || 0);
            deselectedMoreFilters.push(`priceRange=${min}-${max}`);
          }
          if (properties.area?.min || properties.area?.max) {
            const min = properties.area.min || 0;
            const max = properties.area.max === 10001 ? '10000plus' : (properties.area.max || 0);
            deselectedMoreFilters.push(`squareFeetRange=${min}-${max}`);
          }
          if (properties.builtYear?.min > 0 || properties.builtYear?.max > 0) {
            const min = properties.builtYear.min === 1799 ? 'Before 1800' : (properties.builtYear.min || 0);
            const max = properties.builtYear.max === 2011 ? 'After 2010' : (properties.builtYear.max || 0);
            deselectedMoreFilters.push(`yearBuiltRange=${min}-${max}`);
          }
          if (properties.bedrooms) deselectedMoreFilters.push(`bed=${properties.bedrooms}`);
          if (properties.bathrooms) deselectedMoreFilters.push(`bath=${properties.bathrooms}`);

          trackFilterInteraction('FILTER_DESELECTED', {
            deselectedFilters: deselectedMoreFilters.join(',') || 'more_filters_cleared'
          });

          trackButtonClick({
            eventName: "filter_toggle",
            eventParams: { action: "cleared", filter_type: "more_filters" },
            eventSource: "SRP FILTERS",
            eventCategory: "NEW-SRP",
            eventLabel: `All Filters Deselected: ${deselectedMoreFilters.join(',') || 'more_filters_cleared'} | Location: ${getSrpLocationLabel()}`,
          });
        }}
      />
      )
      FilterComponent[7] = (
        polygonId !== "0000000" && !pathname?.includes('near-me') && (
          <SaveSearchButton
            key="searchbutton"
            isMobView={isMobView}
            setShowModal={setShowModal}
          />
        )
      )
    })
    return FilterComponent;
  }
  return (
    <ul className="sasw_list mb-0">
      {srpFilterInitData.length > 0 ? (
        getFilterComponent()
      ) : (
        <div className="listing_list_style text-align-left p0 m0 mt22">
          <div className="list-inline-item pr30" key="shimmer1">
            <ShimmerButton size="sm" />
          </div>
          <div className="list-inline-item pr30" key="shimmer2">
            <ShimmerButton size="sm" />
          </div>
          <div className="list-inline-item pr30" key="shimmer3">
            <ShimmerButton size="sm" />
          </div>
          <div className="list-inline-item pr30" key="shimmer4">
            <ShimmerButton size="sm" />
          </div>
          <div className="list-inline-item pr30" key="shimmer5">
            <ShimmerButton size="sm" />
          </div>
          <div className="list-inline-item pr30" key="shimmer6">
            <ShimmerButton size="sm" />
          </div>
          <div className="list-inline-item pr30" key="shimmer7">
            <ShimmerButton size="sm" />
          </div>
        </div>
      )}
      <SaveSearchModal
        showModal={showModal}
        setShowModal={setShowModal}
        handleClose={() => {
          setShowModal(false);

          const eventCategory = getEventCategory();
          // Get client ID from Google Analytics cookie
          const gaCookie = document.cookie
            .split("; ")
            .find((row) => row.startsWith("_ga="));
          const clientId = gaCookie ? gaCookie.split("=")[1] : "";
          trackButtonClick({
            eventName: "save_search_modal_closed",
            eventSource: "Close Button",
            eventCategory: eventCategory,
            eventLabel: `clientId: ${clientId}`,
          });
        }}
      />
    </ul>
  );
};

export default FilterBar;
